const state = {
  jwt: null
}

const getters = {
  isAuthenticated: (state) => {
    return !!state.jwt
  }
}

const mutations = {
  SET_TOKEN(state, jwt) {
    state.jwt = jwt
    localStorage.setItem('jwt', JSON.stringify(jwt))
  },

  REMOVE_TOKEN(state) {
    state.jwt = null
    localStorage.removeItem('jwt')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
